<template>
  <b-row no-gutters>
    <b-modal
      id="modal-settings"
      ref="settingModal"
      :hide-header="true"
      :hide-footer="true"
      :cancel-disabled="true"
      content-class="blah"
      dialog-class="settingsWrapper"
      body-class="settingsBody"
    >
      <div class="settings flex-row d-flex rounded">
        <div class="menu rounded-left">
          <ul class="list-unstyled">
            <li
              :class="{'selected rounded-top-left': currentPane === 'general'}"
              @click="pickTab('general')">{{ $t('MEETING.SETTINGS_GENERAL') }}
            </li>
            <li
              :class="{'selected': currentPane === 'audio'}"
              @click="pickTab('audio')">{{ $t('MEETING.SETTINGS_AUDIO') }}
            </li>
            <li
              :class="{'selected': currentPane === 'video'}"
              @click="pickTab('video')">{{ $t('MEETING.SETTINGS_VIDEO') }}
            </li>
          </ul>
        </div>
        <div class="content rounded-right">
          <span
            class="closeSettings"
            @click="$refs.settingModal.hide()">x</span>
          <b-container
            fluid
            class="p-0">
            <b-row>
              <b-col v-if="currentPane === 'general'">
                <h4>{{ $t('MEETING.SETTINGS_TITLE') }}</h4>
                <div class="form-label-group light">
                  <b-form-select
                    v-model="language"
                    class="form-control-light"
                    @change="updateLanguage">
                    <b-form-select-option value="en">
                      English - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="fr">
                      Français - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="sk">
                      Slovenčina - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="es">
                      Español - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="ro">
                      Româna - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="it">
                      Italiano - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="pt">
                      Português - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="de">
                      Deutsch - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="fi">
                      Suomi - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="tr">
                      Türkçe - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="nl">
                      Nederlands - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="zh">
                      简体中文 - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="ru">
                      Русский - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="ar">
                      لغة - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="el">
                      Ελληνικά - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="ko">
                      한국어 - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="ja">
                      日本語 - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="ur">
                      زبان - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="ne">
                      भाषा - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="kk">
                      Қазақ тілі - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                    <b-form-select-option value="hi">
                      हिन्दी - {{ $t('MEETING.SETTINGS_DEFAULTLANGUAGE') }}
                    </b-form-select-option>
                  </b-form-select>
                  <label>Language</label>
                </div>
                <hr>
                <div class="form-group light">
                  <b-form-checkbox-group
                    v-model="settings"
                    :options="generalOptions"
                    class="form-control-light"
                    @change="updateSetting(generalOptions)"/>
                </div>
              </b-col>
              <b-col v-if="currentPane === 'audio'">
                <div class="d-flex justify-content-between">
                  <h4>{{ $t('MEETING.SETTINGS_AUDIO_SETTINGS') }}</h4>
                  <button
                    class="d-none d-md-block btn-sm btn btn-secondary-light"
                    style="height: 30px"
                    @click="refreshDevices">
                    {{ $t('MEETING.SETTINGS_RESCAN') }}
                  </button>
                </div>
                <div class="form-control-light form-group">
                  <label>{{ $t('MEETING.SETTINGS_AUDIO_VOLUME') }}</label>
                  <b-form-input
                    id="range"
                    v-model="localVolume"
                    debounce="200"
                    type="range"
                    min="0"
                    max="1"
                    step="0.1"
                    @update="updateVolume"/>
                </div>
                <hr>
                <div class="form-label-group light pushedDown">
                  <b-form-select
                    v-if="browser.chrome"
                    v-model="$parent.selectedSinkId"
                    :disabled="refreshing"
                    class="form-control-light"
                    @change="updateSink">
                    <b-form-select-option
                      v-for="device in $parent.audioOutputDevices"
                      :key="device.deviceId"
                      :value="device.deviceId">
                      <span v-if="device.deviceId === 'default'">{{ $t('MEETING.SETTINGS_DEFAULT_DEVICE') }}</span>
                      {{ device.label }}
                    </b-form-select-option>
                  </b-form-select>
                  <b-form-select
                    v-if="!browser.chrome"
                    v-model="$parent.selectedSinkId"
                    :disabled="refreshing"
                    class="form-control-light">
                    <b-form-select-option
                      v-if="!browser.chrome"
                      value="default">
                      {{ $t('CONFIGURE.DEFAULT_SPEAKERS') }}
                    </b-form-select-option>
                  </b-form-select>
                  <label>{{ $t('MEETING.SETTINGS_AUDIO_SPEAKER') }}</label>
                  <div class="d-flex justify-content-between p-1">
                    <span
                      v-if="!isTestSoundPlaying"
                      id="soundTest"
                      class="testLink"
                      @click="testSound($event)">{{ $t('MEETING.SETTINGS_AUDIO_TEST_SOUND') }}</span>
                    <span
                      v-else
                      id="soundTestStop"
                      class="testLink"
                      @click="stopSound($event)">{{ $t('MEETING.SETTINGS_AUDIO_STOP_SOUND') }}</span>
                    <volume-indicator
                      :display="!isTestSoundPlaying"
                      :media="$parent.audioDom.srcObject"
                      class="volume bg-black-30"
                    />
                    <volume-indicator
                      v-if="isTestSoundPlaying"
                      :display="true"
                      :media="testMedia"
                      class="volume bg-black"
                    />
                  </div>
                </div>

                <div class="form-label-group light">
                  <b-form-select
                    v-model="$parent.selectedMicId"
                    :disabled="refreshing"
                    class="form-control-light"
                    p-1
                    @change="updateMic">
                    <b-form-select-option
                      v-for="device in $parent.audioDevices"
                      :key="device.deviceId"
                      :value="device.deviceId">
                      <span v-if="device.deviceId === 'default'">{{ $t('MEETING.SETTINGS_DEFAULT_DEVICE') }}</span>
                      {{ device.label }}
                    </b-form-select-option>
                  </b-form-select>
                  <label>{{ $t('MEETING.SETTINGS_AUDIO_MIC') }}</label>
                  <div
                    :class="{'justify-content-end': browser.safari,
                             'justify-content-between': !browser.safari }"
                    class="d-flex  p-1">
                    <div
                      v-if="!browser.safari"
                      class="d-flex">
                      <span
                        v-if="!recording"
                        class="testLink"
                        @click="startRecording">{{ $t('MEETING.SETTINGS_AUDIO_TEST_MIC') }}</span>
                      <span
                        v-else
                        class="testLink"
                        @click="stopRecording">{{ $t('MEETING.SETTINGS_AUDIO_STOP_REC') }}</span>
                    </div>
                    <div class="d-flex">
                      <volume-indicator
                        v-show="!showLines"
                        ref="micVol"
                        :display="true"
                        :live="!isTestSoundPlaying"
                        :media="$parent.localAudioStream[0].media"
                        class="volume"
                      />
                      <volume-indicator
                        v-if="showLines"
                        ref="micVol2"
                        :display="true"
                        :media="audioMedia"
                        :live="!isTestSoundPlaying"
                        class="volume"
                      />
                    </div>
                  </div>
                </div>
                <hr>
                <div class="form-group light">
                  <b-form-checkbox-group
                    v-model="settings"
                    :options="micOptions"
                    class="form-control-light"
                    @change="updateSetting(micOptions)"/>
                </div>
              </b-col>
              <b-col v-if="currentPane === 'video'">
                <div class="d-flex justify-content-between">
                  <h4>{{ $t('MEETING.SETTING_CAMERA_SETTINGS') }}</h4>
                  <button
                    class="d-none d-md-block btn-sm btn btn-secondary-light"
                    style="height: 30px"
                    @click="refreshDevices">{{ $t('MEETING.SETTINGS_RESCAN') }}</button>
                </div>
                <div class="form-label-group light pushedDown">
                  <b-form-select
                    v-model="$parent.selectedCameraId"
                    :disabled="refreshing"
                    class="form-control-light"
                    @change="updateCamera">
                    <b-form-select-option
                      v-for="device in $parent.videoDevices"
                      :key="device.deviceId"
                      :value="device.deviceId">
                      <span v-if="device.deviceId === 'default'">{{ $t('MEETING.SETTINGS_DEFAULT_DEVICE') }}</span>
                      {{ device.label }}
                    </b-form-select-option>
                  </b-form-select>
                  <label>{{ $t('MEETING.SETTINGS_CAMERA') }}</label>
                </div>
                <hr>
                <div class="form-group light">
                  <b-form-checkbox-group
                    v-model="settings"
                    :options="videoOptions"
                    class="form-control-light"
                    @change="updateSetting(videoOptions)"/>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </b-modal>
    <audio
      ref="recorded"
      class="d-none"
      controls
    />
  </b-row>
</template>

<script>
import {ref} from "@vue/composition-api"
import VolumeIndicator from "./VolumeIndicator";
import {loadStorageData, getItem, setItem} from "../functions/storageManager"
import {getBrowser} from "../functions/browserDetails";
import { gaEvent } from "../functions/gtag";

export default {
  name: 'Settings',
  components: {
    VolumeIndicator,
  },
  setup(props, context) {
    loadStorageData()
    const settings = ref([])
    let browser = getBrowser()
    const language = ref('en')
    const currentPane = ref('general');
    const audioMedia = ref(new MediaStream());
    const testMedia = ref(new MediaStream());
    let recordedBlobs = []
    const showLines = ref(false);
    const refreshing = ref(false);
    const recording = ref(false);
    const localVolume  = ref(1);
    let mediaRecorder = {}
    const isTestSoundPlaying = ref(false);
    let previousMic = null;
    let previousSound = null;
    let sound = {}

    const generalOptions = ref([
      {text: context.root.$t("LOGIN.SKIP_LABEL"), value: 'directly'},
      {text: context.root.$t("LOGIN.PREF_MEETINGS_SOUNDS"), value: 'soundNotify'},
      {text: context.root.$t("MEETING.POPUP_ASK_TO_CONFIRM"), value: 'confirmLeave'},
    ])
    const micOptions = ref([
      {text: context.root.$t("CONFIGURE.MIC_CHECK"), value: 'miceOn'}
    ])
    const videoOptions = ref([
      {text: context.root.$t("CONFIGURE.CAMERA_MIRROR"), value: 'cameraMirror'},
      {text: context.root.$t("CONFIGURE.CAMERA_CHECK"), value: 'cameraOn'}
    ])
    load()
    if (typeof getItem('soundNotify') === 'undefined' ) {
      settings.value.push('soundNotify')
      setItem('soundNotify', true)
    }
    if (typeof getItem('cameraMirror') === 'undefined' ) {
      settings.value.push('cameraMirror')
      setItem('cameraMirror', true)
    }

    function init () {
      loadStorageData()
      load()
    }

    function updateLanguage() {
      setItem('language', language.value)
      context.root.$i18n.locale = language.value
      refreshLang()
    }

    function updateSetting(settingGroup) {
      settingGroup.forEach(
          value => {
            if (value.value === 'cameraMirror') {
              gaEvent({'ACTION': 'action', 'video_features': 'mirror'});
            }
            setItem(value.value, settings.value.includes(value.value))
          }
      )
    }


    function pickTab(tab) {
      currentPane.value = tab;
    }

    function refreshLang() {
      generalOptions.value = [
        {text: context.root.$t("LOGIN.SKIP_LABEL"), value: 'directly'},
        {text: context.root.$t("LOGIN.PREF_MEETINGS_SOUNDS"), value: 'soundNotify'},
        {text: context.root.$t("MEETING.POPUP_ASK_TO_CONFIRM"), value: 'confirmLeave'},
      ]
      micOptions.value = [
        {text: context.root.$t("CONFIGURE.MIC_CHECK"), value: 'miceOn'}
      ]
      videoOptions.value = [
        {text: context.root.$t("CONFIGURE.CAMERA_MIRROR"), value: 'cameraMirror'},
        {text: context.root.$t("CONFIGURE.CAMERA_CHECK"), value: 'cameraOn'}
      ]
    }
    function updateMic(mic){
      let device = context.parent.audioDevices.find(device => device.deviceId === mic );
      if (audioMedia.value.getAudioTracks().length > 0) {
        audioMedia.value.getAudioTracks()[0].stop();
      }
      if (context.refs.micVol)
        context.refs.micVol.removeMedia()
      if (context.refs.micVol2)
        context.refs.micVol2.removeMedia()
      if (context.parent.$refs.meetingControls.$refs.miceVolume)
        context.parent.$refs.meetingControls.$refs.miceVolume.removeMedia()
      context.parent.changeDevice(device, 'audio', true)
    }

    function updateCamera(camera){
      let device = context.parent.videoDevices.find(device => device.deviceId === camera );
      context.parent.changeDevice(device, 'video', true)
    }

    async function load() {
      generalOptions.value.forEach(
          value => {
            if (getItem(value.value)) {
              if (!settings.value.includes(value.value)) {
                settings.value.push(value.value)
              }
            } else {
              settings.value = arrayRemove(settings.value, value.value)
            }
          }
      )
      micOptions.value.forEach(
          value => {
            if (getItem(value.value)) {
              settings.value.push(value.value)
            }
          }
      )
      videoOptions.value.forEach(
          value => {
            if (getItem(value.value)) {
              if (!settings.value.includes(value.value)) {
                settings.value.push(value.value)
              }
            } else {
              settings.value = arrayRemove(settings.value, value.value)
            }
          }
      )

      if (getItem('language')) {
        language.value = getItem('language')
      } else {
        language.value = context.root.$i18n.locale
      }
    }

    function arrayRemove(arr, value) {
      return arr.filter(function(ele){
          return ele != value
      })
    }

    async function updateSink(device) {
      await context.parent.audioDom.setSinkId(device);
      setItem('sinkId', device)
      console.log('Audio is being played on ' + device);
    }

    function testSound(e) {
      previousMic = context.parent.$refs.meetingControls.mic;
      sound = document.getElementById('test');
      isTestSoundPlaying.value = true;
      if (browser.chrome) {
        testMedia.value = sound.captureStream()
      }
      context.parent.$refs.meetingControls.mic = false;
       sound.addEventListener('ended', (event) => {
         isTestSoundPlaying.value = false;
         context.parent.$refs.meetingControls.mic = previousMic;
       });
      sound.volume = localVolume.value
      if (context.parent.selectedSinkId === 'default') {
        sound.play();
      } else {
        sound.setSinkId(context.parent.selectedSinkId);
        sound.play();
      }
    }

    function stopSound(){
      sound.pause();
      sound.currentTime = 0;
      isTestSoundPlaying.value = false;
      context.parent.$refs.meetingControls.mic = previousMic;
    }

    async function refreshDevices() {
      refreshing.value = true;
      let devices = await navigator.mediaDevices.enumerateDevices()

      context.parent.audioDevices = []
      context.parent.videoDevices = []
      context.parent.audioOutputDevices = []
      devices.forEach((E) => {
        if (E.kind === 'videoinput') {
          if (context.parent.videoDevices.findIndex(el => el.deviceId === E.deviceId) < 0) {
            context.parent.videoDevices.push(E)
          }
        } else if (E.kind === 'audioinput') {
          if (context.parent.audioDevices.findIndex(el => el.deviceId === E.deviceId) < 0) {
            context.parent.audioDevices.push(E)
          }
        } else if (E.kind === 'audiooutput') {
          if (context.parent.audioOutputDevices.findIndex(el => el.deviceId === E.deviceId) < 0) {
            context.parent.audioOutputDevices.push(E)
          }
        }
      })
      setTimeout(function() {
        refreshing.value = false;
      },400)
    }

    function startRecording() {
      recording.value = true;
      removeTracks(audioMedia.value)
      recordedBlobs = []
      previousMic = context.parent.$refs.meetingControls.mic;
      previousSound = context.parent.$refs.meetingControls.speaker;
      context.parent.$refs.meetingControls.mic = false;
      audioMedia.value.addTrack(context.parent.localAudioStream[0].media.getAudioTracks()[0].clone(), context.parent.localAudioStream[0])
      audioMedia.value.getAudioTracks()[0].enabled = true
      showLines.value= true;
      var options = {mimeType: 'video/webm'}
      if (!MediaRecorder.isTypeSupported(options.mimeType)) {
        context.root.$notify.error(options.mimeType + ' is not Supported')
      }
      try {
        mediaRecorder = new MediaRecorder(audioMedia.value, options)
      } catch (e) {
        context.root.$notify.error('Exception while creating MediaRecorder' + e + '. mimeType: ' + options.mimeType)
        return
      }
      context.parent.$refs.meetingControls.speaker = false;
      mediaRecorder.ondataavailable = handleDataAvailable
      mediaRecorder.start(10) // collect 10ms of data
    }

    function stopRecording() {
      showLines.value = false;
      recording.value= false;
      mediaRecorder.stop()
      context.refs.recorded.style.display = 'block'
      play()
    }

    function handleDataAvailable(event) {
      if (event.data && event.data.size > 0) {
        recordedBlobs.push(event.data)
      }
    }

    function play() {
      let superBuffer = new Blob(recordedBlobs, {type: 'audio/webm'})
      context.refs.recorded.src = window.URL.createObjectURL(superBuffer)
      if(browser.chrome) {
        context.refs.recorded.setSinkId(context.parent.selectedSinkId);
      }
      context.refs.recorded.addEventListener('ended', (event) => {
        context.parent.$refs.meetingControls.speaker = true;
        context.parent.$refs.meetingControls.mic = previousMic
        context.parent.$refs.meetingControls.speaker = previousSound
      });
      context.refs.recorded.play();
    }

    function removeTracks(media) {
      if (media) {
        media.getTracks().forEach((track) => {
          track.stop()
          media.removeTrack(track)
        })
      }
    }

    function updateVolume(vol){
      context.parent.audioDom.volume = vol;
    }


    return {
      recording,
      currentPane,
      language,
      generalOptions,
      settings,
      updateSetting,
      updateLanguage,
      micOptions,
      pickTab,
      updateSink,
      testSound,
      browser,
      updateMic,
      refreshDevices,
      startRecording,
      stopRecording,
      audioMedia,
      updateVolume,
      showLines,
      localVolume,
      videoOptions,
      updateCamera,
      isTestSoundPlaying,
      testMedia,
      stopSound,
      refreshing,
      init
    }
  }
}
</script>
<style>

.closeSettings{
  position: absolute;
  top: 10px;
  right: 15px;
  font-weight: 600;
  color:#282828;
  cursor: pointer;
}
.closeSettings:hover{
  color: #E72113;
}

.settings {
  height: 100%;
  min-height: 400px;
}

.settingsWrapper {
  max-width: 705px;
  padding: 0;
}

.settings .menu {
  width: 150px;
}

.settings .menu ul {
}

.settings .menu li {
  padding: 0 16px;
  font-weight: 600;
  color: #F0F0F0;
  font-size: 14px;
  line-height: 36px;
}
.settings .menu li:hover{
  background-color: #284465;
}

.settings .menu li.selected {
  background-color: #0059B2;
}

.settings .content {
  background-color: #ffffff;
  width: 100%;
  padding: 15px;
}

.settings .content h4 {
  color: #282828;
  margin-bottom: 40px;
}

.settings .custom-checkbox label {
  font-size: 14px;
}
.settings label{
  font-size: 12px;
  font-weight: 600;
  color:#6E6E6E;
}

.testLink{
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color:#2166B2;
}
.pushedDown{
  margin-top: 32px;
}
.settings .volume{
  margin-top: 4px;
  display: flex;
}
.settingsBody {
  min-height: 400px;
  background-color: #363636;
  padding: 0;
  border-radius: .25rem !important;
}

.rounded-top-left {
  border-top-left-radius: .25rem
}
@media (min-width: 768px) {
  .settings .content {
    padding: 32px 41px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue